










































































import Vue from 'vue';
// import { getAllConferences } from '@/api/conference';
import { logout } from '@/api/user';
import AddConference from '@/components/AddConference/index.vue';
import Confirmation from '@/components/Confirmation/index.vue';
// eslint-disable-next-line no-unused-vars
import { conferenceType } from '@/types/api';

export default Vue.extend({
  name: 'Home',
  components: {
    AddConference,
    Confirmation,
  },
  data() {
    return {
      config: {
        handler: () => {
          // @ts-ignore
          this.showConfirm = 'add';
        },
        middleware: (event) => event.target.className !== 'cancel',
        events: ['click', 'touchstart', 'touchmove'],
      },
      showConf: false as boolean,
      showConfirm: false as boolean,
    };
  },
  created() {
    // this.updateConferencesData();
  },
  methods: {
    dateFormat(d): string {
      const sDate = new Date(d);
      const ye = (y) => new Intl.DateTimeFormat('en', { year: 'numeric' }).format(y);
      const mo = (m) => new Intl.DateTimeFormat('en', { month: '2-digit' }).format(m);
      const da = (day) => new Intl.DateTimeFormat('en', { day: '2-digit' }).format(day);
      return `${ye(sDate)}-${mo(sDate)}-${da(sDate)}`;
    },
    ongoing(items: conferenceType.getAllConferences[]): conferenceType.getAllConferences[] {
      const dt: Date = new Date(Date.now());
      return items.filter((item) => {
        const a: Date = new Date(item.start_date);
        const b: Date = new Date(item.end_date);
        const c: Date = new Date(b.getTime());
        c.setDate(c.getDate() + 1);
        return dt >= a && dt < c;
      });
    },
    // async updateConferencesData(): Promise<void> {
    //   try {
    //     const conferences = await getAllConferences();
    //     if (conferences.data.data !== null) {
    //       this.conferences = this.sortData(conferences.data.data, 'date', 'down');
    //     }
    //   } catch (err) {
    //     console.error(err);
    //   }
    // },
    sortData(
      items: conferenceType.getAllConferences[],
      type: string,
      dir: string,
    ): conferenceType.getAllConferences[] {
      const sort = items;
      if (type === 'date') {
        sort.sort((a, b) => {
          const dateA = Date.parse(a.end_date);
          const dateB = Date.parse(b.end_date);
          let compare;
          switch (dir) {
            case 'down':
              compare = dateA > dateB;
              break;
            case 'up':
              compare = dateA < dateB;
              break;
            default:
          }
          switch (compare) {
            case true:
              return -1;
            case false:
              return 1;
            default:
              return 0;
          }
        });
      }
      if (sort.length > 5) sort.length = 5;
      return items;
    },
    outside(): void {
      this.showConf = false;
    },
    async changeAcc(): Promise<void> {
      try {
        await logout();
        this.$store.dispatch('logout');
        this.$router.push('/login');
      } catch (err) {
        console.error(err);
      }
    },
  },
  computed: {
    conferences(): any[] {
      return [
        {
          _id: 'example',
          title: 'Example Conference',
          start_date: new Date(Date.now()).toISOString(),
          end_date: new Date(Date.now() + (3600 * 1001 * 24)).toISOString(),
          rules: {
            majority: '1/2 Delegates + 1',
            dr_vote: '2/3 Delegates',
            quorum: '2/3 Delegates',
            rounding: 'Round Down',
          },
          chairman: [{
            _id: 'john',
            email: 'johndoe@example.com',
          },
          {
            _id: 'admin',
            email: 'admin@example.com',
          }],
          delegates: [
            {
              _id: 'indonesia',
              country: 'Indonesia',
              status: 'present',
            },
            {
              _id: 'usa',
              country: 'United States of America',
              status: 'present & voting',
            },
          ],
          // gsl: {
          //   current: 0,
          //   length: 0,
          //   queue: []
          // },
        },
        {
          _id: 'future',
          title: 'Future Conference',
          start_date: new Date(Date.now() + (3600 * 1001 * 24)).toISOString(),
          end_date: new Date(Date.now() + (3600 * 1001 * 24 * 2)).toISOString(),
          rules: {
            majority: '1/2 Delegates + 1',
            dr_vote: '2/3 Delegates',
            quorum: '2/3 Delegates',
            rounding: 'Round Down',
          },
          chairman: [{
            _id: 'john',
            email: 'johndoe@example.com',
          },
          {
            _id: 'admin',
            email: 'admin@example.com',
          }],
          delegates: [
            {
              _id: 'indonesia',
              country: 'Indonesia',
              status: 'present',
            },
            {
              _id: 'usa',
              country: 'United States of America',
              status: 'present & voting',
            },
          ],
          // gsl: {
          //   current: 0,
          //   length: 0,
          //   queue: []
          // },
        },
      ] as conferenceType.getAllConferences[];
    },
  },
});
